import { h } from 'preact';
import * as BaseComp from 'components/bolt/header/headerExpanded.js';
import Store from 'store/store';
// import s from 'components/bolt/header/headerExpanded.sss';

export default class HeaderExpanded extends BaseComp.default {
	trackNavLink(linkName) {
		Store.emit('CUSTOM_EVENT', {
			category: 'header',
			action: 'nav-link-click',
			label: linkName
		});
	}
}
